// Package Imports
import axios from "axios";
import { toJS } from "mobx";

// Project Imports
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import AuthStore from "../../../login/store/AuthStore";
import updateProductwiseRiskData from "../updateProductwiseRiskData";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../constants/Constants";

const changeLaApiCall = async (familyProductIdData, needType, apiUrl) => {
  const journeyData = toJS(AuthStore.journeyData);
  let { journey_details } = journeyData;
  let riskList = [];
  let requestList = [];

  if (needType !== NeedTypeEnum.PROTECTION_FOR_MY_FAMILY) {
    if (journey_details.high_risk_selected) {
      riskList.push("high");
    }
    riskList = [...riskList, ...["medium", "low"]];
    riskList.forEach((item) => {
      requestList.push({
        family_product_id: familyProductIdData.family_product_details_id,
        journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        risk_type: item,
      });
    });
  } else {
    requestList.push({
      family_product_id: familyProductIdData.family_product_details_id,
      journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
      risk_type: "high",
    });
  }
  const promises = [];
  requestList.forEach(async (item) => {
    promises.push(axios.post(apiUrl, item));
  });
  promises.map((item) =>
    item.then((result) => updateProductwiseRiskData(result))
  );
};

export default changeLaApiCall;
